{
  "success": true,
  "message": "Estado de transferible actualizado correctamente."
}
